// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"antTooltipOverlay_tooltipWrapper__hIbqG"};